import { Award, ShieldCheck, SlidersHorizontal } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const ABOUT_IMG =
  "https://images.pexels.com/photos/7937313/pexels-photo-7937313.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const PILLARS = [
  { icon: Award, title: "Quality", text: "Workmanship, materials and finishing held to a high standard on every project." },
  { icon: ShieldCheck, title: "Reliability", text: "Trusted trades, clear schedules and a team that delivers what it commits to." },
  { icon: SlidersHorizontal, title: "Project Control", text: "One point of contact and full oversight from planning through to completion." },
];

export const About = () => (
  <section id="about" data-testid="about-section" className="relative bg-[#050B14] py-24 sm:py-32">
    <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20">
      <Reveal>
        <div className="relative">
          <div className="absolute -left-4 -top-4 h-full w-full border border-[#C5A059]/30" />
          <img
            src={ABOUT_IMG}
            alt="Premium property interior delivered by Tyrell Property Services"
            className="relative h-[420px] w-full object-cover sm:h-[520px]"
          />
          <div className="absolute -bottom-5 -right-3 bg-[#C5A059] px-6 py-4 sm:-right-5">
            <span className="font-serif text-lg uppercase tracking-[0.15em] text-[#050B14]">Essex, UK</span>
          </div>
        </div>
      </Reveal>

      <div>
        <Reveal>
          <div className="mb-6 flex items-center gap-4">
            <span className="h-px w-12 bg-gradient-to-r from-[#C5A059] to-transparent" />
            <span className="text-[11px] font-semibold uppercase tracking-[0.35em] text-[#C5A059]">
              About Tyrell Property Services
            </span>
          </div>
          <h2 className="font-serif text-3xl font-light uppercase leading-snug tracking-tight text-white sm:text-4xl lg:text-5xl">
            Built Around <span className="gold-text-gradient">Your Vision.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-8 text-base font-light leading-relaxed text-slate-300 sm:text-lg">
            Tyrell Property Services provides professional property construction, renovation,
            refurbishment and project management services across Essex and surrounding areas.
          </p>
          <p className="mt-5 text-base font-light leading-relaxed text-slate-400">
            From individual renovations to larger property transformations, we coordinate
            trusted trades, manage projects and maintain a high standard from initial
            planning through to completion.
          </p>
          <p className="mt-5 border-l-2 border-[#C5A059] pl-5 font-serif text-lg italic text-[#F8F6F0] sm:text-xl">
            Our approach is simple: clear communication, quality workmanship and
            professional project delivery.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-4 sm:grid-cols-3">
          {PILLARS.map((p, i) => (
            <Reveal key={p.title} delay={0.15 + i * 0.12}>
              <div
                data-testid={`pillar-card-${p.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="group border border-[#C5A059]/20 bg-[#0E1726]/70 p-5 transition-all duration-500 hover:border-[#C5A059] hover:shadow-[0_0_30px_rgba(197,160,89,0.15)]"
              >
                <p.icon size={26} className="text-[#C5A059] transition-transform duration-500 group-hover:-translate-y-1" strokeWidth={1.5} />
                <h3 className="mt-4 text-xs font-bold uppercase tracking-[0.22em] text-white">{p.title}</h3>
                <p className="mt-2 text-xs leading-relaxed text-slate-400">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
